import { Journey } from 'Global/Journey/Types/Journey';
import AdditionalBookingSectionEntity from 'Models/Entities/AdditionalBookingSectionEntity';
import { FreightTabDto } from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { FreightBookingDetailState } from '../../BookingWizardData/FreightBookingWizardData';
import { BulkFreightDetailsFormAction } from './BulkFreightDetailsFormState';
import ShipmentCardCollapsed from './ShipmentCardCollapsed';
import ShipmentCardExpanded from './ShipmentCardExpanded';

interface Props {
	freightElements: FreightTabDto;
	addOnSections: AdditionalBookingSectionEntity[];
	journey: Journey;
	userId: string;
	state: FreightBookingDetailState;
	dispatch: (action: BulkFreightDetailsFormAction) => void;
	hasMultipleItems: boolean;
	isExpanded?: boolean;
}

export default function ShipmentCard({
	freightElements,
	addOnSections,
	journey,
	userId,
	state,
	dispatch,
	hasMultipleItems,
	isExpanded,
}: Props) {
	if (isExpanded) {
		return (
			<ShipmentCardExpanded
				freightElements={freightElements}
				addOnSections={addOnSections}
				journey={journey}
				userId={userId}
				state={state}
				dispatch={dispatch}
				hasMultipleItems={hasMultipleItems}
			/>
		);
	}
	return (
		<ShipmentCardCollapsed
			freightElements={freightElements}
			journey={journey}
			userId={userId}
			state={state}
			dispatch={dispatch}
		/>
	);
}
